<template>
  <v-card flat class="pwc-event-speaker">
    <v-img
      class="pwc-speaker-avatar"
      width="160"
      height="160"
      :src="cAvatar"
    />
    <v-card-title class="pwc-speaker-title">
      <span>{{ profile.name }}</span>
    </v-card-title>
    <v-card-title class="pwc-speaker-title">
      <span>{{ profile.title }}</span>
      <span> / </span>
      <span>{{ profile.company }}</span>
    </v-card-title>
    <v-card-text class="pwc-speaker-introduction">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="cDescription" />
    </v-card-text>
  </v-card>
</template>

<script>
import getConfig from '@/config/index'

export default {
  props: {
    profile: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    cAvatar() {
      return getConfig().PUBLIC_URL + this.profile.portraitUrl
    },
    cDescription() {
      const arr = (this.profile.introduction || '').split('\n')
      let appendString = '<ul>'
      for (const key in arr) {
        appendString = appendString + '<li>' + arr[key] + '</li>'
      }
      appendString = appendString + '</ul>'
      return appendString
    }
  }

}
</script>

<style lang="scss" scoped>
.pwc-event-speaker {
    max-width: 400px;
    padding-top: 16px;

    .pwc-speaker-avatar {
        border: 50%;
        margin: auto;
    }
    .pwc-speaker-title {
        justify-content: center;
        span {
          font-size: 14px;
        }
    }
    .pwc-speaker-introduction {
        display: flex;
        justify-content: center;
        span {
          font-size: 14px;
        }
    }
}
</style>

